import { Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export default function initQuicklinks() {
  Alpine.data('quicklinks', () => ({
    init() {
      const swiperEl = this.$el.querySelector('.quicklinks-swiper');
      if (swiperEl) {
        /* eslint-disable no-new */
        new Swiper(swiperEl as HTMLElement, {
          modules: [Navigation],
          slidesPerView: 'auto',
          navigation: {
            nextEl: `#${this.$el.id} .quicklinks-swiper-button-next`,
            prevEl: `#${this.$el.id} .quicklinks-swiper-button-prev`,
            disabledClass: 'hidden',
          },
          spaceBetween: 12,
          breakpoints: {
            1024: {
              spaceBetween: 24,
            },
          },
        });
      }
    },
  }));
}
